/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKSocialButton from "components/MKSocialButton";
import MKTypography from "components/MKTypography";

// mui Icons
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import GamesIcon from "@mui/icons-material/SportsEsports";

import gamingResume from "assets/documents/Matthew Christian - Gameplay Engineer Resume.pdf";

function IntroSection() {
  return (
    <MKBox
      bgColor="#343434"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={{ xs: 5, sm: 5, md: 5 }}
      mb={{ xs: 5, sm: 5, md: 5 }}
      mx={3}
    >
      <MKBox
        variant="gradient"
        bgColor="info"
        coloredShadow="secondary"
        borderRadius="lg"
        p={2}
        mx={2}
        mt={-3}
      >
        <MKTypography variant="h1" color="white" sx={{ textAlign: "center" }}>
          Matthew Christian
        </MKTypography>
        <MKTypography variant="h4" color="white" sx={{ textAlign: "center" }}>
          Backend & Gameplay Engineer
        </MKTypography>
        <MKTypography variant="body2" color="white" sx={{ textAlign: "center" }}>
          Madison, Wisconsin USA
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="body2" color="white" mb={3}>
          Adaptive gameplay engineer with 18+ years in hands-on engineering experience developing
          standalone titles, web applications, and backend products across Gaming, Insurance, and
          Technology. Shipped AAA and indie titles across PC, consoles, and mobile. Experienced in
          agile response to shifting technical needs and ability to pick up new technologies quickly
          and effectively. Proficient in industry-standard engines and online games. Passionate
          about trailblazing workflows and building robust, maintainable code for technically
          challenging projects in a collaborative environment.
          <br />
          <br />
          <strong>Languages:</strong> C++, C#, Java, JavaScript, TypeScript, HTML/CSS, SQL
          <br />
          <strong>Engines & Tools:</strong> Unreal Engine, Unity, Visual Studio, Perforce, JIRA,
          Confluence
          <br />
          <strong>Additional Skills:</strong> Cloud (Azure, AWS), Repositories (GIT, SVN), Web
          (Node.js, ASP.NET)
        </MKTypography>
        <center>
          <MKButton
            color="info"
            href={gamingResume}
            sx={{ mr: 3 }}
            target="_blank"
            referrerPolicy="no-referrer"
          >
            View Resume
          </MKButton>
          <MKSocialButton
            component="a"
            href="https://www.linkedin.com/in/matthewchristian/"
            target="_blank"
            color="linkedin"
            size="large"
            iconOnly
            circular
            sx={{ mr: 3 }}
          >
            <LinkedInIcon />
          </MKSocialButton>
          <MKSocialButton
            component="a"
            href="https://github.com/matchristian"
            target="_blank"
            color="github"
            size="large"
            iconOnly
            circular
            sx={{ mr: 3 }}
          >
            <GitHubIcon />
          </MKSocialButton>
          <MKSocialButton
            component="a"
            href="https://matchristiandev.itch.io/"
            target="_blank"
            color="youtube"
            size="large"
            iconOnly
            circular
          >
            <GamesIcon />
          </MKSocialButton>
        </center>
      </MKBox>
    </MKBox>
  );
}

export default IntroSection;
